<template>
  <editor-menu-bar
    :editor="editor"
    v-slot="{ commands, isActive, menu, focused }"
  >
    <div class="menubar">
      <div class="buttons-row field has-addons">
        <p class="control has-icons" v-if="bold">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.bold() }"
            @click="commands.bold"
            data-tooltip="Pogrubienie"
          >
            <icon name="fa-bold" />
          </button>
        </p>
        <p class="control has-icons" v-if="italic">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.italic() }"
            @click="commands.italic"
            data-tooltip="Kursywa"
          >
            <icon name="fa-italic" />
          </button>
        </p>
        <p class="control has-icons" v-if="underline">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.underline() }"
            @click="commands.underline"
            data-tooltip="Podkreślenie"
          >
            <icon name="fa-underline" />
          </button>
        </p>
        <p class="control has-icons" v-if="strike">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.strike() }"
            @click="commands.strike"
            data-tooltip="Przekreślenie"
          >
            <icon name="fa-strikethrough" />
          </button>
        </p>
        <p class="control has-icons" v-if="link">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.link() || linkMenu }"
            @click="handleLinkClick(isActive.link(), commands.link)"
            data-tooltip="Link"
          >
            <icon name="fa-link" />
          </button>
        </p>
        <div class="control has-icons">
          <form
            @submit.prevent="setLinkUrl(commands.link, linkUrl)"
            v-if="linkMenu"
          >
            <input
              type="text"
              class="input is-small"
              ref="linkUrl"
              @blur="hideLinkMenu"
              @keydown.esc="hideLinkMenu"
              placeholder="Wprowadź adres i naciśnij enter..."
              v-model.trim="linkUrl"
            />
          </form>
        </div>
        <p class="control has-icons" v-for="level in heading" :key="level">
          <button
            type="button"
            class="button heading-button is-small"
            :class="{ 'is-primary': isActive.heading({ level }) }"
            @click="commands.heading({ level })"
            :data-tooltip="`Nagłówek ${level}`"
          >
            <span>H{{ level }}</span>
          </button>
        </p>
        <p class="control has-icons" v-if="bulletList">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.bullet_list() }"
            @click="commands.bullet_list"
            data-tooltip="Lista punktowana"
          >
            <icon name="fa-list-ul" />
          </button>
        </p>
        <p class="control has-icons" v-if="orderedList">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.ordered_list() }"
            @click="commands.ordered_list"
            data-tooltip="Lista numerowana"
          >
            <icon name="fa-list-ol" />
          </button>
        </p>
        <p class="control has-icons" v-if="line">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.horizontal_rule() }"
            @click="commands.horizontal_rule"
            data-tooltip="Pozioma linia"
          >
            <span class="icon">
              <span class="fa-stack">
                <i class="fas fa-minus fa-stack-1x" style="left: -0.1rem"></i>
                <i class="fas fa-minus fa-stack-1x" style="left: 0.1rem"></i>
              </span>
            </span>
          </button>
        </p>
        <p class="control has-icons" v-if="blockquote">
          <button
            type="button"
            class="button is-small"
            :class="{ 'is-primary': isActive.blockquote() }"
            @click="commands.blockquote"
            data-tooltip="Cytat"
          >
            <icon name="fa-quote-right" />
          </button>
        </p>
        <p class="control has-icons" v-if="undo">
          <button
            type="button"
            class="button is-small"
            @click="commands.undo"
            data-tooltip="Cofnij"
          >
            <icon name="fa-undo" />
          </button>
        </p>
        <p class="control has-icons" v-if="redo">
          <button
            type="button"
            class="button is-small"
            @click="commands.redo"
            data-tooltip="Ponów"
          >
            <icon name="fa-redo" />
          </button>
        </p>
        <p class="control has-icons" v-if="table">
          <button
            type="button"
            class="button is-small"
            @click="
              commands.createTable({
                rowsCount: 3,
                colsCount: 3,
                withHeaderRow: false
              })
            "
            data-tooltip="Tabela"
          >
            <icon name="fa-table" />
          </button>
        </p>
        <template v-if="table && isActive.table()">
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.deleteTable"
              data-tooltip="Usuń tabelę"
            >
              <span class="icon">
                <span class="fa-stack">
                  <i class="fas fa-table fa-stack-1x"></i>
                  <i
                    class="fas fa-times fa-stack-1x"
                    style="font-size: 0.5rem; top: 0.5rem; left: 0.5rem"
                  ></i>
                </span>
              </span>
            </button>
          </p>
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.addColumnBefore"
              data-tooltip="Dodaj kolumnę po lewej"
            >
              <span class="icon">
                <span class="fa-stack">
                  <i
                    class="fas fa-ellipsis-v fa-stack-1x"
                    style="left: 0.2rem"
                  ></i>
                  <i
                    class="fas fa-plus fa-stack-1x"
                    style="font-size: 0.5rem; left: -0.3rem"
                  ></i>
                </span>
              </span>
            </button>
          </p>
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.addColumnAfter"
              data-tooltip="Dodaj kolumnę po prawej"
            >
              <span class="icon">
                <span class="fa-stack">
                  <i
                    class="fas fa-ellipsis-v fa-stack-1x"
                    style="left: -0.2rem"
                  ></i>
                  <i
                    class="fas fa-plus fa-stack-1x"
                    style="font-size: 0.5rem; left: 0.3rem"
                  ></i>
                </span>
              </span>
            </button>
          </p>
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.deleteColumn"
              data-tooltip="Usuń kolumnę"
            >
              <span class="icon">
                <span class="fa-stack">
                  <i class="fas fa-ellipsis-v fa-stack-1x"></i>
                  <i
                    class="fas fa-times fa-stack-1x"
                    style="font-size: 0.5rem; top: 0.5rem; left: 0.5rem"
                  ></i>
                </span>
              </span>
            </button>
          </p>
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.addRowBefore"
              data-tooltip="Dodaj wiersz powyżej"
            >
              <span class="icon">
                <span class="fa-stack">
                  <i
                    class="fas fa-ellipsis-h fa-stack-1x"
                    style="top: 0.1rem"
                  ></i>
                  <i
                    class="fas fa-plus fa-stack-1x"
                    style="font-size: 0.5rem; bottom: 0.3rem"
                  ></i>
                </span>
              </span>
            </button>
          </p>
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.addRowAfter"
              data-tooltip="Dodaj wiersz poniżej"
            >
              <span class="icon">
                <span class="fa-stack">
                  <i
                    class="fas fa-ellipsis-h fa-stack-1x"
                    style="bottom: 0.1rem"
                  ></i>
                  <i
                    class="fas fa-plus fa-stack-1x"
                    style="font-size: 0.5rem; top: 0.3rem"
                  ></i>
                </span>
              </span>
            </button>
          </p>
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.deleteRow"
              data-tooltip="Usuń wiersz"
            >
              <span class="icon">
                <span class="fa-stack">
                  <i class="fas fa-ellipsis-h fa-stack-1x"></i>
                  <i
                    class="fas fa-times fa-stack-1x"
                    style="font-size: 0.5rem; top: 0.5rem; left: 0.5rem"
                  ></i>
                </span>
              </span>
            </button>
          </p>
          <p class="control has-icons">
            <button
              type="button"
              class="button is-small"
              @click="commands.toggleCellMerge"
              data-tooltip="Scal komórki"
            >
              <icon name="fa-border-none" />
            </button>
          </p>
        </template>
      </div>
    </div>
  </editor-menu-bar>
</template>

<script>
import { Editor, EditorMenuBar } from "tiptap";
import Icon from "%helpers/Icon"; // for some reason, importing from "%helpers" does not work

const formatUrl = url => (url.match(/^[a-zA-Z]+:\/\//) ? url : "http://" + url);

export default {
  name: "editor-menu",

  components: {
    EditorMenuBar,
    Icon
  },

  props: {
    editor: Editor,
    bold: Boolean,
    italic: Boolean,
    underline: Boolean,
    strike: Boolean,
    heading: Array,
    bulletList: Boolean,
    orderedList: Boolean,
    line: Boolean,
    link: Boolean,
    blockquote: Boolean,
    table: Boolean,
    undo: Boolean,
    redo: Boolean
  },

  data() {
    return {
      linkMenu: false,
      linkUrl: ""
    };
  },

  methods: {
    async handleLinkClick(isActive, command) {
      if (!isActive) {
        this.linkMenu = true;
        await this.$nextTick();
        this.$refs.linkUrl.focus();
      } else {
        command({ href: null });
      }
    },

    hideLinkMenu() {
      this.linkMenu = false;
      this.linkUrl = "";
    },

    setLinkUrl(command, url) {
      command({ href: formatUrl(url) });
      this.hideLinkMenu();
    }
  }
};
</script>

<style lang="scss" scoped>
.heading-button span {
  font-family: $family-sans-serif;
  font-weight: 700;
}

.buttons-row {
  margin-bottom: 0;
}
</style>
